export default function getPrevMatchedItemsState() {
    return {
        data: JSON.parse(localStorage.getItem('matches')) || []
    };
}



// WEBPACK FOOTER //
// ./src/Menu/Reducer/getPrevMatchedItemsState.js